import {Injectable} from "@angular/core";
import {ComponentStore} from "@ngrx/component-store";
import {Store} from "@ngrx/store";
import {AppState} from "../../../store/store";
import {withLatestFrom} from "rxjs";
import {selectSite, selectSites} from "../../../store/init/init.selectors";
import {tap} from "rxjs/operators";
import {Serializer, Serializers} from "../../../interfaces/serializer";
import {Site} from "../../../interfaces/site";
import {DataSource} from "../../../interfaces/data-source";
import {initSite} from "../../../store/init/init.actions";
import {Router} from "@angular/router";
import {NotificationComponentObject} from "../../../classes/notification-component-object";
import {dialogOpen} from "../../../store/dialog/dialog.actions";
import {IframeDialogComponent} from "../../../../settings/data-sources/data-sources-listing/iframe-dialog/iframe-dialog.component";
import {NotificationStore} from "../notification.store";

@Injectable()
export class NotificationDataSourceTemplateStore extends ComponentStore<any> {
  public readonly onReconnectClick = this.effect((params$: any): any => params$.pipe(
    withLatestFrom(this._store.select(selectSites), this._store.select(selectSite)),
    tap(([params, sites, current]: [{ site: Serializer<Site>, data_set_usages: Serializers<DataSource>, notification: NotificationComponentObject }, Serializers<Site>, Serializer<Site>]): void => {
      if (current.id != params.site.id) {
        this._store.dispatch(initSite({site: sites.find((item: Serializer<Site>): boolean => item.id === params.site.id)}));
      }

      if (params.data_set_usages.length == 1) {
        this._router.navigate([params.site.id, 'data-sources', 'list']);
        this._store.dispatch(dialogOpen({
          component: IframeDialogComponent,
          data: {
            inputData: {
              link: params.site.id + '/data-sources/' + params.data_set_usages[0].relationships.data_source.data.id + '/' + params.data_set_usages[0].id + '/start'
            }
          },
          config: {
            width: '800px',
            height: '600px'
          },
          disableClose: false
        }));
      } else {
        this._router.navigate([params.site.id, 'data-sources', 'list']);
      }

      this._notificationStore.markAsRead({ notification: params.notification, closeMenu: true });
    })
  ));

  constructor(
    private readonly _store: Store<AppState>,
    private readonly _router: Router,
    private readonly _notificationStore: NotificationStore
  ) {
    super();
  }
}
